import {useCountryUnsafe} from '../country/CountryContext';
import {NZ} from 'bigdatr-style';
import useFeatureFlags from '~/util/useFeatureFlags';

/** True when country is NZ and the hideCategoryOnNz feature flag is on. */
export default function useHideCategoryForNz(): boolean {
    const context = useCountryUnsafe();
    // if we cant get the country from context, dont hide anything. this would happen for non logged in users
    const {hideCategoryOnNz} = useFeatureFlags();
    if (!context?.country) return false;
    return Boolean(context.country === NZ && hideCategoryOnNz);
}
